import React from 'react';
import { FaCheck, FaCog, FaInfoCircle, FaLightbulb } from 'react-icons/fa';
import { MdReportGmailerrorred } from 'react-icons/md';
import { getLcn } from '~/utils/labeled-classnames';

const infoBoxTypeConfig = {
  info: {
    icon: <FaInfoCircle />,
    bg: 'bg-blue-500/10',
    iconColor: 'text-blue-500/60',
  },
  config: {
    icon: <FaCog />,
    bg: 'bg-gray-500/10',
    iconColor: 'text-gray-500/60',
  },
  highlighted: {
    icon: <FaLightbulb />,
    bg: 'bg-yellow-500/10',
    iconColor: 'text-yellow-500/60',
  },
  error: {
    icon: <MdReportGmailerrorred />,
    bg: 'bg-red-500/10',
    iconColor: 'text-red-500/60',
  },
  success: {
    icon: <FaCheck />,
    bg: 'bg-green-500/10',
    iconColor: 'text-green-500/60',
  },
} as const;

export default function InfoBox({
  icon,
  children,
  type,
}: {
  icon?: React.ReactNode,
  children?: React.ReactNode
  type?: keyof typeof infoBoxTypeConfig,
}) {

  type = type || 'info'
  icon = icon || infoBoxTypeConfig[type].icon

  const lcn = getLcn({
    highlightedSection: [
      'flex gap-4 p-4 rounded-md relative overflow-hidden',
      infoBoxTypeConfig[type].bg,
    ],
    iconCell: [
      'flex-shrink-0 text-4xl',
      infoBoxTypeConfig[type].iconColor,
    ],
    iconBg: [
      'absolute right-[-5%] top-[50%] translate-y-[-50%] rotate-12 opacity-[0.08] text-[20rem]',
      infoBoxTypeConfig[type].iconColor,
    ],
    contentCell: 'flex-grow flex flex-col gap-5 justify-center ',
  });

  return (
    <div className={lcn.highlightedSection}>
      <div className={lcn.iconBg}>
        {icon}
      </div>
      <div className={lcn.iconCell}>
        {icon}
      </div>
      <div className={lcn.contentCell}>
        {children}
      </div>
    </div>
  );
}; 